import { openBlock as r, createElementBlock as n, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return r(), n("svg", o, [...e[0] || (e[0] = [
    t("text", {
      "xml:space": "preserve",
      fill: "currentColor",
      "font-family": "Pretendard GOV",
      "font-size": "10",
      "letter-spacing": "-.1",
      style: { "white-space": "pre" }
    }, [
      t("tspan", {
        x: "6.298",
        y: "15.555"
      }, "1h")
    ], -1)
  ])]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
